import React, { useContext } from "react";
import "../../../assets/css/tms-layout/tms-layout.scss";
import { BaseContext } from "../../../contexts/BaseContext";
// import { BaseContext } from "../../../contexts/BaseContext";
// import moment from "moment";
// import { FormatNumberINRCurrency } from "../../../utils/tms-currency-formatter/tms-curreny-formatter";
// import { aathreya } from "../../../assets/images/tms-image-list";
// import { Divider } from "antd";
const TmsFooter = () => {
  // const { shiftData } = useContext(BaseContext);
  return (
    <>
      {/* {shiftData && (
        <div className="vf-footer">
          <img src={aathreya} width={80} height={22} />
          <Divider type="vertical" />
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <p>Login POS Name: {shiftData?.shiftDetails?.counterName}</p>
            <p>
              Total Amount:
              {FormatNumberINRCurrency(
                // (shiftData?.amountDeposited ?? 0) +
                //   (shiftData?.accServicesAmount ?? 0) +
                (shiftData?.darshanam_services_amount ?? 0) +
                  // (shiftData?.sevaServicesAmount ?? 0) +
                  (shiftData?.annadanam_services_amount ?? 0) +
                  (shiftData?.gstAmount ?? 0)
                // (shiftData?.deliveryAmount ?? 0) +
                // (shiftData?.prasadamServicesAmount ?? 0) +
                // (shiftData?.donationServicesAmount ?? 0) +
                // (shiftData?.publicationServicesAmount ?? 0) +
                // (shiftData?.kalyanakattaServicesAmount ?? 0) +
                // (shiftData?.tollgateServicesAmount ?? 0) +
                // (shiftData?.thulabharamServicesAmount ?? 0) +
                // (shiftData?.shopProductAmount ?? 0) +
                // (shiftData?.manualEntryServicesAmount ?? 0) +
                // (shiftData?.accAdvanceBookingCharge ?? 0) +
                // (shiftData?.accMaintenanceCharge ?? 0) +
                // (shiftData?.busServicesAmount ?? 0) +
                // (shiftData?.miscProductServicesAmount ?? 0) +
                // //R&L
                // (shiftData?.landLeaseServicesAmount ?? 0) +
                // (shiftData?.licenseLeaseServicesAmount ?? 0) +
                // (shiftData?.shopLeaseServicesAmount ?? 0)
              )}
            </p>
            <p>Total Tickets: {Number(shiftData?.transactions_count ?? 0)}</p>
            <p>
              Login Time:
              {moment(shiftData?.login).format("DD-MM-YYYY HH:mm:ss A")}
            </p>
          </div>
        </div>
      )} */}
    </>
  );
};
export default TmsFooter;
